import React from "react";

export const STATUS_OPTIONS = ["ACTIVE", "UNDER_REVIEW", "SUSPENDED", "PENDING"];

export const STATUS_COLOR = {
  ACTIVE: "var(--rg-sage)",
  UNDER_REVIEW: "var(--rg-amber)",
  SUSPENDED: "var(--rg-red)",
  PENDING: "var(--rg-sage)",
};

export function Card({ label, value, valueColor, testId }) {
  return (
    <div className="rounded-md border border-[var(--rg-border)] bg-[var(--rg-surface)] p-3" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-[0.18em] text-[var(--rg-muted)] font-bold">{label}</div>
      <div className="font-heading font-extrabold text-2xl mt-1" style={{ color: valueColor || "#FFFFFF" }}>{value}</div>
    </div>
  );
}
